<template>
  <div class="wrap">
    <el-row>
      <el-col :span="16">
        <Logo />
        <el-form :inline="true" :model="formInline" class="search-form">
          <el-form-item label="">
              <el-input v-model="formInline.keywords" size="small" style="width: 400px;" placeholder="input"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="small"  @click="onSearch">SEARCH</el-button>
              </el-form-item>
          </el-form>
      </el-col>
      <el-col :span="8" style="text-align: right;">
        <Navigation />
      </el-col>
    </el-row>
    <GoodsList />
  </div>
</template>

<script>
import Logo from '@/components/logo'
import Navigation from '@/components/navigation'
import GoodsList from '@/components/GoodsList'
export default {
  name: 'Garment',
  components: {Logo, Navigation, GoodsList},
  data () {
    return {
      formInline: {
        keyword: ''
      }
    }
  },
  methods: {
    onSearch () {}
  }
}
</script>

<style scoped>
.wrap {
  width: 1300px;
  margin: 0 auto;
}
.search-form {
  display: inline-block;
  float: left;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/garment/index.vue